import { useCallback, useEffect, useState } from 'react';

export function useAsync(factory, dependencies = []) {
  const [state, setState] = useState({ loading: true, data: null, error: null });
  const execute = useCallback(async () => {
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const data = await factory();
      setState({ loading: false, data, error: null });
      return data;
    } catch (error) {
      setState({ loading: false, data: null, error });
      return null;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
  useEffect(() => { execute(); }, [execute]);
  return { ...state, reload: execute };
}
